import { updatedMedia } from 'client/styles'
import styled from 'styled-components'

export const LandingsContainer = styled.div`
  a {
    text-decoration: none;
  }

  margin-block-start: 57px;

  ${updatedMedia.tablet} {
    margin-block-start: 65px;
  }

  ${updatedMedia.desktop} {
    margin-block-start: 89px;
  }
`
